import { LoginProvider } from "./../providers/login/login";
import { RemoteServicesProvider } from "./../providers/remote-services/remote-services";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { GeolocalizationProvider } from "../providers/geolocalization/geolocalization";
import { LocalstorageProvider } from "./../providers/localstorage/localstorage";
import { GmapsProvider } from "./../providers/gmaps/gmaps";
import * as _ from "lodash";
import { SpotData } from "dto";

@Injectable()
export class RootStore {
	selectedGroupId: BehaviorSubject<number>;
    currentPosition: BehaviorSubject<any>;
    selectedPOS: BehaviorSubject<any>;
    spotData: BehaviorSubject<SpotData>;
	userGroups: any[] = [];
	posList: any[] = [];
	posTypeList: any[] = [];
	products: any[] = [];
	survey: any[] = [];
	tips: any[] = [];
    rankings:any[] = [];
	config = { enablePosCode: false };

	constructor(
		public loginProvider: LoginProvider,
		public remoteService: RemoteServicesProvider,
		private geolocalizationProvider: GeolocalizationProvider,
		private gmaps: GmapsProvider,
		public storage: LocalstorageProvider
	) {
        this.selectedGroupId = new BehaviorSubject<number>(null);
        this.selectedPOS = new BehaviorSubject<any>(null);
        this.spotData = new BehaviorSubject<SpotData>(null);
        
		this.setup();
	}

	startupLoadData() {
		this.loadListData(this.loginProvider.posType, this.posTypeList);
		this.configGroup(this.loginProvider.config, null, this.loginProvider.groups);
		return this.userGroups;
	}
   
    async getUserRanking() {
		let ranking = (await this.remoteService.getUserRankings(
			this.loginProvider.token
		)) as any[];
		this.loadListData(ranking, this.rankings);
    }

    async getRankingPositions(groupId) {
		return await this.remoteService.getRankingPositions(
            groupId,
			this.loginProvider.token
        );
    }
    
	async getPOSList(position = null) {
        let currentPosition = position ? position : this.geolocalizationProvider.currentPosition.getValue();
		var selectedGroup = this.getSelectedGroup();
		var radius = this.gmaps.getRadiusFromZoom();

		let data: any = await this.remoteService.getPosNearby(
			currentPosition.lat,
            currentPosition.lng,
			radius,
            selectedGroup ? selectedGroup.id : 0,
			this.loginProvider.token
		);
		this.loadListData(data, this.posList);
	}

	findPos(id) {
		let index = _.findIndex(this.posList, function (o) {
			return o.id === id;
		});
		return this.posList[index];
	}

    public async loadGroupData(groupId) {
        if (groupId) {
            // Tips
            let tips = (await this.remoteService.getTips(
                groupId,
                this.loginProvider.token
            )) as any[];
            this.loadListData(tips, this.tips);
                
            // Products
            let products = (await this.remoteService.getProducts(
                groupId,
                this.loginProvider.token
            )) as any[];
            this.loadListData(products, this.products);
            
            // Survey
            let survey = (await this.remoteService.getSurvey(
                groupId,
                this.loginProvider.token
            )) as any[];
            this.loadListData(survey, this.survey);

            //Refresh POS list
            await this.getPOSList();

            //Default selected POS
            if (this.posList.length > 0) {
                this.selectedPOS.next(this.posList[0]);
            }
        }
    }

	private setup() {
		
		this.selectedGroupId.subscribe(groupId => this.loadGroupData(groupId));

		// Current location
		this.geolocalizationProvider.currentPosition.subscribe(async location => {
			if (location && this.loginProvider.isLogged()) {
				this.getPOSList();
			}
		});

		// Login trigger
		this.loginProvider.loginEvent.subscribe(async data => {
			this.getPOSList();
		});
	}

	async loadConfig(autoSelectGroup = true) {

		let data: any = (await this.remoteService.getConfig(
			this.geolocalizationProvider.currentPosition.value,
			this.loginProvider.token
		)) as any[];

		if (data && data.posType) {
			this.loadListData(data.posType, this.posTypeList);
		}

		if (data && data.groups) {
			this.configGroup(data.config, data.areaGroupId, data.groups, autoSelectGroup);
		}

		return this.userGroups;
	}

	private configGroup(config, areaGroupId, groups, autoSelectGroup = true) {

		// Load group
		this.loadListData(groups, this.userGroups);

		// Load config
		this.config = config;

        if(autoSelectGroup){
            let storageData = JSON.parse(this.storage.read("selectedGroup"));

            // Select group
            if (areaGroupId) {
                this.selectedGroupId.next(areaGroupId);
            }
            else if (storageData !== null && storageData.group && storageData.group.id > 0
                && groups.length > 0 && groups.findIndex(x => x.id == storageData.group.id)) {
                this.selectedGroupId.next(storageData.group.id);
            }
            else if (groups.length > 0) {
                this.selectedGroupId.next(groups[0].id);
            }
        }
	}

	getSelectedGroup() {
		if (this.selectedGroupId.value) {
			let result = _.filter(this.userGroups, data => data.id === this.selectedGroupId.value);
			return _.first(result);
		}
		return null;
    }
    
    getDefaultGroupBanner() {
        var selectedGroup = this.getSelectedGroup();
        if(selectedGroup && selectedGroup.bannerActive && selectedGroup.bannerUrlImage){
            return selectedGroup;
        }
        /*else{
            let result = _.filter(this.userGroups, data => data.anyUser && data.bannerActive && data.bannerUrlImage);
            return _.first(result);
        }*/
	}

	private loadListData(source: any[], destiny: any[]) {
		destiny.length = 0;
		if (source) {
			source.forEach(item => {
				destiny.push(item);
			});
		}
	}
}
